module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/imgadvisor_spotlight_desktop_01@2x-6d50f06870938be2ee46976fe3e7e349.jpg";